<form *ngIf="statusForm" [formGroup]="statusForm" class="definition-form" id="ce-prj4-form">
  <mat-label class="display-title" id="ce-prj4-status-label">Select Project Status*</mat-label>
  <br />
  <mat-radio-group formControlName="projectStatus" class="project-status" id="ce-prj4-status-group">
    <mat-radio-button *ngFor="let ps of projectstatus; let i = index" [value]="ps.id" id="ce-prj4-status-{{ i }}">
      {{ ps.appStatusTitle }}<br />
      <mat-label id="ce-prj4-status-desc-{{ i }}" class="lbl-sub">{{ ps.appStatusDescription }}</mat-label>
    </mat-radio-button>
  </mat-radio-group>
  <mat-error
    class="error-msg"
    id="ce-prj4-status-err"
    *ngIf="
      statusForm.get('projectStatus')?.invalid &&
      (statusForm.get('projectStatus')?.touched || statusForm.get('projectStatus')?.dirty)
    "
  >
    Please select a project status.
  </mat-error>
  <hr class="separator" />
  <mat-label id="ce-prj4-icon-label" class="display-title">Select Project Icon*</mat-label>
  <mat-radio-group formControlName="projectIcon" class="icon-radio-group" id="ce-prj4-icon-group">
    <ng-container *ngFor="let icon of icons; let j = index">
      <mat-radio-button [value]="icon.id" class="icon-radio">
        <span class="icon-radio-circle" [class.selected]="statusForm.get('projectIcon')?.value === icon.id">
          <!-- <mat-icon>{{ icon.icon_title }}</mat-icon> -->
          <app-icon-display [icon]="icon" [cssClass]="'project-selection-icon'" id="ce-prj4-icon-icn-{{ j }}">
          </app-icon-display>
          <span
            *ngIf="statusForm.get('projectIcon')?.value === icon.id"
            class="icon-radio-check"
            id="ce-prj4-icon-chk-{{ j }}"
          >
            <mat-icon>check_circle</mat-icon>
          </span>
        </span>
      </mat-radio-button>
    </ng-container>
  </mat-radio-group>
  <mat-error
    class="error-msg"
    id="ce-prj4-icon-err"
    *ngIf="
      statusForm.get('projectIcon')?.invalid &&
      (statusForm.get('projectIcon')?.touched || statusForm.get('projectIcon')?.dirty)
    "
  >
    Please select a project icon.
  </mat-error>
</form>
